// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h2 id="use-the-va-facility-api-to-find-relevant-information-about-a-specific-va-facility.-for-each-va-facility%2C-you'll-find-contact-information%2C-location%2C-hours-of-operation-and-available-services.-for-medical-facilities-only%2C-we-provide-data-on-appointment-wait-times-and-patient-satisfaction.">Use the VA Facility API to find relevant information about a specific VA facility. For each VA facility, you'll find contact information, location, hours of operation and available services. For medical facilities only, we provide data on appointment wait times and patient satisfaction.</h2>
    </div>
  );
};

export default MarkdownComponent;
